import { createSlice } from "@reduxjs/toolkit";
import {
  addCollectionToPlaylistBuilder,
  createPlaylistBuilder,
  editPlaylistBuilder,
  fetchMyPlaylistsBuilder,
  fetchPlaylistBuilder,
  fetchPlaylistsBuilder,
  removePlaylistBuilder,
} from "./builder";
import { LOGOUT } from "../../../utils/constants";

const initialState = {
  playlists: {
    data: [],
    filter: "MOST_POPULAR",
    search: "",
    page: 1,
    total: 0,
    loading: false,
    error: null,
  },
  myPlaylists: {
    data: [],
    isFetched: false,
    loading: false,
  },
  playlist: {
    data: {},
    page: 1,
    total: 0,
    loading: true,
    error: null,
  },
  pending: {
    createPlaylist: false,
    removePlaylist: false,
    addCollectionToPlaylist: false,
    editPlaylist: false,
  },
};

export const paymentSlice = createSlice({
  name: "playlistsInfo",
  initialState,
  reducers: {
    setSelectedPlaylistFilter: (state, { payload }) => {
      state.playlists.filter = payload;
    },
    setSelectedPlaylistSearch: (state, { payload }) => {
      state.playlists.search = payload;
    },
    resetPlaylist: (state) => {
      state.playlist = {
        data: {},
        page: 1,
        total: 0,
        loading: true,
        error: null,
      };
    },

    resetState: () => initialState,
  },
  extraReducers: (builder) => {
    createPlaylistBuilder(builder);
    fetchPlaylistsBuilder(builder);
    fetchPlaylistBuilder(builder);
    fetchMyPlaylistsBuilder(builder);
    addCollectionToPlaylistBuilder(builder);
    editPlaylistBuilder(builder);
    removePlaylistBuilder(builder);
    builder.addCase(LOGOUT, (state) => ({
      ...initialState,
    }));
  },
});

export const {
  resetState,
  setSelectedPlaylistFilter,
  setSelectedPlaylistSearch,
  resetPlaylist,
} = paymentSlice.actions;

export const selectPlaylistPending = (state) => state.playlistsInfo.pending;

export const selectPlaylists = (state) => state.playlistsInfo.playlists;
export const selectPlaylist = (state) => state.playlistsInfo.playlist;
export const selectMyPlaylists = (state) => state.playlistsInfo.myPlaylists;

export default paymentSlice.reducer;
